// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player_bar_container {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  min-width: 800px;
  height: 9vh;
  min-height: 80px;
  max-height: 120px;
  z-index: 9;
}

.player_bar {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #334155 0%, #334155 45%, #1E293B 55%, #1E293B 100%);
  border: 1.5px solid #2DD4BF;
  outline: 1px solid rgba(45, 212, 191, 0.3);
  outline-offset: -4px;
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(45, 212, 191, 0.15), inset 0 0 30px rgba(45, 212, 191, 0.05);
  clip-path: polygon(
    30px 0,
    calc(100% - 30px) 0,
    100% 100%,
    0 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
  overflow: hidden;
}

.player_bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(45, 212, 191, 0.2),
    transparent
  );
  transform: skewX(-25deg);
  animation: shimmer 4s infinite;
}

@keyframes shimmer {
  0% {
    left: -150%;
  }
  50% {
    left: 150%;
  }
  100% {
    left: 150%;
  }
}

.player_bar_stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 400px;
  height: 56px;
}

.player_bar_stat {
  display: flex;
  align-items: center;
  gap: 1px;
  height: 24px;
  position: relative;
}

.player_bar_stat:first-child {
  margin-top: 4px;
}

.player_bar_stat_icon {
  background: linear-gradient(135deg, #2a3746 0%, #1c1f25 100%);
  border: 1px solid #3c616c;
  padding: 4px 8px 4px 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 48px;
}

.player_bar_stat_icon img {
  width: 16px;
  height: 16px;
}

.player_bar_stat_icon span {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  text-shadow: 0 0 4px rgba(81, 253, 255, 0.5);
  font-family: 'Kim';
}

.player_bar_stat_value {
  font-family: 'Kim';
  font-size: 16px;
  color: #ffffff;
  min-width: 70px;
  text-align: right;
}

@media screen and (max-width: 1500px) and (orientation: landscape) {
  .player_bar_container {
    width: 65%;
    transform: translateX(-50%) scale(0.95);
    transform-origin: bottom center;
  }
}

@media screen and (max-width: 1440px) {
  .player_bar_container {
    width: 75%;
    transform: translateX(-50%) scale(0.85);
  }
  
  .player_bar_actions_container {
    transform: scale(0.85) translateX(5%);
  }
}

@media screen and (max-width: 1366px) {
  .player_bar_container {
    width: 80%;
    transform: translateX(-50%) scale(0.8);
  }
  
  .player_bar_actions_container {
    transform: scale(0.8) translateX(8%);
    top: -35px;
  }
  
  .player_bar_stats {
    max-width: 350px;
  }
  
  .player_bar_turn_info {
    left: 60px;
  }
}

@media screen and (max-width: 1100px) and (orientation: landscape) {
  .player_bar_container {
    width: 90%;
    transform: translateX(-50%) scale(0.75);
  }
  
  .player_bar_actions_container {
    transform: scale(0.75) translateX(12%);
  }
}

@media screen and (max-width: 980px) and (orientation: landscape) {
  .player_bar_container {
    width: 95%;
    transform: translateX(-50%) scale(0.65);
  }
  
  .player_bar_actions_container {
    transform: scale(0.65) translateX(15%) translateY(-15%);
  }
}

.player_bar_statuses {
  position: absolute;
  left: calc(100% + 12px);
  top: 90%;
  transform: translateY(-50%);
  display: flex;
  gap: 6px;
  align-items: center;
  white-space: nowrap;
}

.player_bar_statuses div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: 'Kim';
  color: #ffffff;
  background: rgba(28, 31, 37, 0.6);
  padding: 2px 4px;
  border-radius: 3px;
}

.player_bar_statuses img {
  width: 20px;
  height: 22px;
  background-color: #1c1f25;
  padding: 2px;
  border-radius: 2px;
  background: linear-gradient(135deg, #1c1f25 0%, #2a3746 100%);
  border: 1px solid #3c616c;
  transition: all 0.2s ease;
}

.player_bar_statuses img:hover {
  transform: scale(1.1);
  border-color: #51fdff;
  box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);
}

.enemy_turn_banner {
  position: absolute;
  left: 50%;
  /* top: 50%; */
  transform: translate(-50%, -50%);
  min-width: 300px;
  padding: 12px 40px;
  z-index: 1;
  
  /* Container styling */
  background: linear-gradient(
    90deg,
    rgba(28, 31, 37, 0) 0%,
    rgba(202, 48, 77, 0.3) 20%,
    rgba(202, 48, 77, 0.4) 50%,
    rgba(202, 48, 77, 0.3) 80%,
    rgba(28, 31, 37, 0) 100%
  );
  border-radius: 4px;
  
  /* Text styling */
  font-family: 'Kim', sans-serif;
  font-size: 24px;
  color: #ffffff;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 
    0 0 10px rgba(202, 48, 77, 0.8),
    -1px -1px 0 #ca304d,
    1px -1px 0 #ca304d,
    -1px 1px 0 #ca304d,
    1px 1px 0 #ca304d;
  
  /* Animation */
  animation: enemyTurnPulse 2s infinite;
}

@keyframes enemyTurnPulse {
  0%, 100% {
    box-shadow: 
      0 0 20px rgba(202, 48, 77, 0.3),
      inset 0 0 20px rgba(202, 48, 77, 0.3);
  }
  50% {
    box-shadow: 
      0 0 30px rgba(202, 48, 77, 0.5),
      inset 0 0 30px rgba(202, 48, 77, 0.5);
  }
}

.player_bar_turn_info {
  position: absolute;
  left: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.player_bar_turn_banner {
  background: linear-gradient(
    90deg,
    rgba(28, 31, 37, 0) 0%,
    rgba(69, 131, 208, 0.3) 20%,
    rgba(69, 131, 208, 0.4) 50%,
    rgba(69, 131, 208, 0.3) 80%,
    rgba(28, 31, 37, 0) 100%
  );
  padding: 4px 16px;
  border-radius: 4px;
  font-family: 'Kim', sans-serif;
  font-size: 18px;
  color: #ffffff;
  text-transform: uppercase;
  text-shadow: 
    0 0 8px rgba(69, 131, 208, 0.8),
    -1px -1px 0 #4583d0,
    1px -1px 0 #4583d0,
    -1px 1px 0 #4583d0,
    1px 1px 0 #4583d0;
}

.player_bar_controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.player_bar_pass_turn {
  width: 64px;
  height: 64px;
  padding: 8px 0;
  font-family: 'Kim';
  font-size: 16px;
  text-transform: uppercase;
  color: #ffffff;
  background: linear-gradient(to bottom, #2a3746 0%, #1c1f25 100%);
  border: 1px solid #3c616c;
  border-radius: 4px;
  cursor: var(--game-pointer);
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.2;
  position: relative;
  z-index: 10;
}

.player_bar_pass_turn:hover {
  border-color: #51fdff;
  box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);
}

.player_bar_pass_turn:active {
  transform: scale(0.98);
  background: linear-gradient(to bottom, #1c1f25 0%, #2a3746 100%);
}

.player_bar_pass_turn span {
  width: 100%;
  text-align: center;
}

.player_bar_pass_turn::before {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  z-index: -1;
}

.player_bar .circular_timer {
  transform: scale(0.8);
}

/* Default state - with animations */
.progressBarFancyContainer .progressFill {
  transition: all 0.3s ease-in-out;
}

.progressBarFancyContainer .particlesContainer {
  transition: all 0.3s ease-in-out;
}

/* No animation state */
.no-progress-animation .progressBarFancyContainer .progressFill,
.no-progress-animation .progressBarFancyContainer .particlesContainer {
  transition: none;
}

.player_bar_actions_container {
  position: absolute;
  left: calc(100%);
  top: -10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 400px;
  z-index: 11;
}

.player_bar_action_row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.player_bar_actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.player_bar_action {
  position: relative;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #2a3746 0%, #1c1f25 100%);
  border: 1px solid #3c616c;
  border-radius: 4px;
  cursor: var(--game-pointer);
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  padding-top: 4px;
  justify-content: center;
  align-items: center;
}

.player_bar_action:hover {
  border-color: #51fdff;
  box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);
}

.player_bar_action.pending-action {
  animation: oscillate-brightness 0.5s ease-in-out infinite;
}

.player_bar_action_name {
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-family: 'Kim';
  font-size: 12px;
  color: #ffffff;
  text-shadow: 
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000,
    0 0 4px rgba(45, 212, 191, 0.5);
  pointer-events: none;
}

@keyframes oscillate-brightness {
  0%,
  100% {
    filter: brightness(1);
  }

  50% {
    filter: brightness(1.6);
  }
}

/* Responsive adjustments */
@media screen and (max-width: 1500px) and (orientation: landscape) {
  .player_bar_actions_container {
    transform: scale(0.9);
  }
}

@media screen and (max-width: 1400px) and (orientation: landscape) {
  .player_bar_actions_container {
    transform: scale(0.9);
  }
}

@media screen and (max-width: 1100px) and (orientation: landscape) {
  .player_bar_actions_container {
    transform: scale(0.9);
  }
}

@media screen and (max-width: 980px) and (orientation: landscape) {
  .player_bar_actions_container {
    transform: scale(1.3) translateX(10%) translateY(-10%);
  }
}

.player_bar_key-binding {
  position: absolute;
  bottom: 0px;
  right: 4px;
  color: white;   
  font-size: 14px; 
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: 'Kim';
  pointer-events: none;
  z-index: 1;
}

.player_bar_item-icon {
  width: 48px;
  height: 48px;
  background-repeat: no-repeat;
  border-radius: 6px;
  background-position: center;
  margin-top: 8px;
}

.player_bar_item-icon-pointer {
  cursor: var(--game-pointer);
}

.player_bar_item-icon-off {
  filter: grayscale(1);
}

.player_bar_silenced_message {
  display: flex;
  align-items: center;
  padding: 16px 16px;
  background: linear-gradient(
    90deg,
    rgba(28, 31, 37, 0) 0%,
    rgba(202, 48, 77, 0.3) 20%,
    rgba(202, 48, 77, 0.4) 50%,
    rgba(202, 48, 77, 0.3) 80%,
    rgba(28, 31, 37, 0) 100%
  );
  border-radius: 4px;
  font-family: 'Kim', sans-serif;
  font-size: 16px;
  color: #ffffff;
  text-shadow: 
    0 0 8px rgba(202, 48, 77, 0.8),
    -1px -1px 0 #ca304d,
    1px -1px 0 #ca304d,
    -1px 1px 0 #ca304d,
    1px 1px 0 #ca304d;
  animation: silencedPulse 2s infinite;
}

@keyframes silencedPulse {
  0%, 100% {
    box-shadow: 
      0 0 15px rgba(202, 48, 77, 0.2),
      inset 0 0 15px rgba(202, 48, 77, 0.2);
  }
  50% {
    box-shadow: 
      0 0 20px rgba(202, 48, 77, 0.4),
      inset 0 0 20px rgba(202, 48, 77, 0.4);
  }
}

/* Add height-based media queries */
@media screen and (max-height: 900px) {
  .player_bar_container {
    height: 11vh;
  }
}

@media screen and (max-height: 768px) {
  .player_bar_container {
    height: 12vh;
  }
  
  .player_bar_actions_container {
    top: -30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HUD/PlayerBar.style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,2BAA2B;EAC3B,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,sFAAsF;EACtF;;;;;GAKC;EACD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;IACpC,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;;EAEV,sBAAsB;EACtB;;;;;;;GAOC;EACD,kBAAkB;;EAElB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB;;;;;qBAKmB;;EAEnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE;IACE;;2CAEuC;EACzC;EACA;IACE;;2CAEuC;EACzC;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;;;;;;;GAOC;EACD,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB;;;;;qBAKmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gEAAgE;EAChE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;;;;mCAKiC;EACjC,oBAAoB;AACtB;;AAEA;EACE;;IAEE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iEAAiE;EACjE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB;;;;;;;GAOC;EACD,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd;;;;;qBAKmB;EACnB,oCAAoC;AACtC;;AAEA;EACE;IACE;;2CAEuC;EACzC;EACA;IACE;;2CAEuC;EACzC;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".player_bar_container {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 50%;\n  min-width: 800px;\n  height: 9vh;\n  min-height: 80px;\n  max-height: 120px;\n  z-index: 9;\n}\n\n.player_bar {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, #334155 0%, #334155 45%, #1E293B 55%, #1E293B 100%);\n  border: 1.5px solid #2DD4BF;\n  outline: 1px solid rgba(45, 212, 191, 0.3);\n  outline-offset: -4px;\n  border-radius: 4px;\n  box-shadow: 0 0 15px rgba(45, 212, 191, 0.15), inset 0 0 30px rgba(45, 212, 191, 0.05);\n  clip-path: polygon(\n    30px 0,\n    calc(100% - 30px) 0,\n    100% 100%,\n    0 100%\n  );\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 40px;\n  overflow: hidden;\n}\n\n.player_bar::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -150%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(45, 212, 191, 0.2),\n    transparent\n  );\n  transform: skewX(-25deg);\n  animation: shimmer 4s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    left: -150%;\n  }\n  50% {\n    left: 150%;\n  }\n  100% {\n    left: 150%;\n  }\n}\n\n.player_bar_stats {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  max-width: 400px;\n  height: 56px;\n}\n\n.player_bar_stat {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  height: 24px;\n  position: relative;\n}\n\n.player_bar_stat:first-child {\n  margin-top: 4px;\n}\n\n.player_bar_stat_icon {\n  background: linear-gradient(135deg, #2a3746 0%, #1c1f25 100%);\n  border: 1px solid #3c616c;\n  padding: 4px 8px 4px 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 48px;\n}\n\n.player_bar_stat_icon img {\n  width: 16px;\n  height: 16px;\n}\n\n.player_bar_stat_icon span {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 500;\n  text-shadow: 0 0 4px rgba(81, 253, 255, 0.5);\n  font-family: 'Kim';\n}\n\n.player_bar_stat_value {\n  font-family: 'Kim';\n  font-size: 16px;\n  color: #ffffff;\n  min-width: 70px;\n  text-align: right;\n}\n\n@media screen and (max-width: 1500px) and (orientation: landscape) {\n  .player_bar_container {\n    width: 65%;\n    transform: translateX(-50%) scale(0.95);\n    transform-origin: bottom center;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .player_bar_container {\n    width: 75%;\n    transform: translateX(-50%) scale(0.85);\n  }\n  \n  .player_bar_actions_container {\n    transform: scale(0.85) translateX(5%);\n  }\n}\n\n@media screen and (max-width: 1366px) {\n  .player_bar_container {\n    width: 80%;\n    transform: translateX(-50%) scale(0.8);\n  }\n  \n  .player_bar_actions_container {\n    transform: scale(0.8) translateX(8%);\n    top: -35px;\n  }\n  \n  .player_bar_stats {\n    max-width: 350px;\n  }\n  \n  .player_bar_turn_info {\n    left: 60px;\n  }\n}\n\n@media screen and (max-width: 1100px) and (orientation: landscape) {\n  .player_bar_container {\n    width: 90%;\n    transform: translateX(-50%) scale(0.75);\n  }\n  \n  .player_bar_actions_container {\n    transform: scale(0.75) translateX(12%);\n  }\n}\n\n@media screen and (max-width: 980px) and (orientation: landscape) {\n  .player_bar_container {\n    width: 95%;\n    transform: translateX(-50%) scale(0.65);\n  }\n  \n  .player_bar_actions_container {\n    transform: scale(0.65) translateX(15%) translateY(-15%);\n  }\n}\n\n.player_bar_statuses {\n  position: absolute;\n  left: calc(100% + 12px);\n  top: 90%;\n  transform: translateY(-50%);\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.player_bar_statuses div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  font-family: 'Kim';\n  color: #ffffff;\n  background: rgba(28, 31, 37, 0.6);\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n\n.player_bar_statuses img {\n  width: 20px;\n  height: 22px;\n  background-color: #1c1f25;\n  padding: 2px;\n  border-radius: 2px;\n  background: linear-gradient(135deg, #1c1f25 0%, #2a3746 100%);\n  border: 1px solid #3c616c;\n  transition: all 0.2s ease;\n}\n\n.player_bar_statuses img:hover {\n  transform: scale(1.1);\n  border-color: #51fdff;\n  box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);\n}\n\n.enemy_turn_banner {\n  position: absolute;\n  left: 50%;\n  /* top: 50%; */\n  transform: translate(-50%, -50%);\n  min-width: 300px;\n  padding: 12px 40px;\n  z-index: 1;\n  \n  /* Container styling */\n  background: linear-gradient(\n    90deg,\n    rgba(28, 31, 37, 0) 0%,\n    rgba(202, 48, 77, 0.3) 20%,\n    rgba(202, 48, 77, 0.4) 50%,\n    rgba(202, 48, 77, 0.3) 80%,\n    rgba(28, 31, 37, 0) 100%\n  );\n  border-radius: 4px;\n  \n  /* Text styling */\n  font-family: 'Kim', sans-serif;\n  font-size: 24px;\n  color: #ffffff;\n  text-align: center;\n  text-transform: uppercase;\n  text-shadow: \n    0 0 10px rgba(202, 48, 77, 0.8),\n    -1px -1px 0 #ca304d,\n    1px -1px 0 #ca304d,\n    -1px 1px 0 #ca304d,\n    1px 1px 0 #ca304d;\n  \n  /* Animation */\n  animation: enemyTurnPulse 2s infinite;\n}\n\n@keyframes enemyTurnPulse {\n  0%, 100% {\n    box-shadow: \n      0 0 20px rgba(202, 48, 77, 0.3),\n      inset 0 0 20px rgba(202, 48, 77, 0.3);\n  }\n  50% {\n    box-shadow: \n      0 0 30px rgba(202, 48, 77, 0.5),\n      inset 0 0 30px rgba(202, 48, 77, 0.5);\n  }\n}\n\n.player_bar_turn_info {\n  position: absolute;\n  left: 80px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.player_bar_turn_banner {\n  background: linear-gradient(\n    90deg,\n    rgba(28, 31, 37, 0) 0%,\n    rgba(69, 131, 208, 0.3) 20%,\n    rgba(69, 131, 208, 0.4) 50%,\n    rgba(69, 131, 208, 0.3) 80%,\n    rgba(28, 31, 37, 0) 100%\n  );\n  padding: 4px 16px;\n  border-radius: 4px;\n  font-family: 'Kim', sans-serif;\n  font-size: 18px;\n  color: #ffffff;\n  text-transform: uppercase;\n  text-shadow: \n    0 0 8px rgba(69, 131, 208, 0.8),\n    -1px -1px 0 #4583d0,\n    1px -1px 0 #4583d0,\n    -1px 1px 0 #4583d0,\n    1px 1px 0 #4583d0;\n}\n\n.player_bar_controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.player_bar_pass_turn {\n  width: 64px;\n  height: 64px;\n  padding: 8px 0;\n  font-family: 'Kim';\n  font-size: 16px;\n  text-transform: uppercase;\n  color: #ffffff;\n  background: linear-gradient(to bottom, #2a3746 0%, #1c1f25 100%);\n  border: 1px solid #3c616c;\n  border-radius: 4px;\n  cursor: var(--game-pointer);\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  line-height: 1.2;\n  position: relative;\n  z-index: 10;\n}\n\n.player_bar_pass_turn:hover {\n  border-color: #51fdff;\n  box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);\n}\n\n.player_bar_pass_turn:active {\n  transform: scale(0.98);\n  background: linear-gradient(to bottom, #1c1f25 0%, #2a3746 100%);\n}\n\n.player_bar_pass_turn span {\n  width: 100%;\n  text-align: center;\n}\n\n.player_bar_pass_turn::before {\n  content: '';\n  position: absolute;\n  top: -5px;\n  left: -5px;\n  right: -5px;\n  bottom: -5px;\n  z-index: -1;\n}\n\n.player_bar .circular_timer {\n  transform: scale(0.8);\n}\n\n/* Default state - with animations */\n.progressBarFancyContainer .progressFill {\n  transition: all 0.3s ease-in-out;\n}\n\n.progressBarFancyContainer .particlesContainer {\n  transition: all 0.3s ease-in-out;\n}\n\n/* No animation state */\n.no-progress-animation .progressBarFancyContainer .progressFill,\n.no-progress-animation .progressBarFancyContainer .particlesContainer {\n  transition: none;\n}\n\n.player_bar_actions_container {\n  position: absolute;\n  left: calc(100%);\n  top: -10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 400px;\n  z-index: 11;\n}\n\n.player_bar_action_row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.player_bar_actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.player_bar_action {\n  position: relative;\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #2a3746 0%, #1c1f25 100%);\n  border: 1px solid #3c616c;\n  border-radius: 4px;\n  cursor: var(--game-pointer);\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  padding-top: 4px;\n  justify-content: center;\n  align-items: center;\n}\n\n.player_bar_action:hover {\n  border-color: #51fdff;\n  box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);\n}\n\n.player_bar_action.pending-action {\n  animation: oscillate-brightness 0.5s ease-in-out infinite;\n}\n\n.player_bar_action_name {\n  position: absolute;\n  top: 2px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  font-family: 'Kim';\n  font-size: 12px;\n  color: #ffffff;\n  text-shadow: \n    -1px -1px 0 #000,\n    1px -1px 0 #000,\n    -1px 1px 0 #000,\n    1px 1px 0 #000,\n    0 0 4px rgba(45, 212, 191, 0.5);\n  pointer-events: none;\n}\n\n@keyframes oscillate-brightness {\n  0%,\n  100% {\n    filter: brightness(1);\n  }\n\n  50% {\n    filter: brightness(1.6);\n  }\n}\n\n/* Responsive adjustments */\n@media screen and (max-width: 1500px) and (orientation: landscape) {\n  .player_bar_actions_container {\n    transform: scale(0.9);\n  }\n}\n\n@media screen and (max-width: 1400px) and (orientation: landscape) {\n  .player_bar_actions_container {\n    transform: scale(0.9);\n  }\n}\n\n@media screen and (max-width: 1100px) and (orientation: landscape) {\n  .player_bar_actions_container {\n    transform: scale(0.9);\n  }\n}\n\n@media screen and (max-width: 980px) and (orientation: landscape) {\n  .player_bar_actions_container {\n    transform: scale(1.3) translateX(10%) translateY(-10%);\n  }\n}\n\n.player_bar_key-binding {\n  position: absolute;\n  bottom: 0px;\n  right: 4px;\n  color: white;   \n  font-size: 14px; \n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: 'Kim';\n  pointer-events: none;\n  z-index: 1;\n}\n\n.player_bar_item-icon {\n  width: 48px;\n  height: 48px;\n  background-repeat: no-repeat;\n  border-radius: 6px;\n  background-position: center;\n  margin-top: 8px;\n}\n\n.player_bar_item-icon-pointer {\n  cursor: var(--game-pointer);\n}\n\n.player_bar_item-icon-off {\n  filter: grayscale(1);\n}\n\n.player_bar_silenced_message {\n  display: flex;\n  align-items: center;\n  padding: 16px 16px;\n  background: linear-gradient(\n    90deg,\n    rgba(28, 31, 37, 0) 0%,\n    rgba(202, 48, 77, 0.3) 20%,\n    rgba(202, 48, 77, 0.4) 50%,\n    rgba(202, 48, 77, 0.3) 80%,\n    rgba(28, 31, 37, 0) 100%\n  );\n  border-radius: 4px;\n  font-family: 'Kim', sans-serif;\n  font-size: 16px;\n  color: #ffffff;\n  text-shadow: \n    0 0 8px rgba(202, 48, 77, 0.8),\n    -1px -1px 0 #ca304d,\n    1px -1px 0 #ca304d,\n    -1px 1px 0 #ca304d,\n    1px 1px 0 #ca304d;\n  animation: silencedPulse 2s infinite;\n}\n\n@keyframes silencedPulse {\n  0%, 100% {\n    box-shadow: \n      0 0 15px rgba(202, 48, 77, 0.2),\n      inset 0 0 15px rgba(202, 48, 77, 0.2);\n  }\n  50% {\n    box-shadow: \n      0 0 20px rgba(202, 48, 77, 0.4),\n      inset 0 0 20px rgba(202, 48, 77, 0.4);\n  }\n}\n\n/* Add height-based media queries */\n@media screen and (max-height: 900px) {\n  .player_bar_container {\n    height: 11vh;\n  }\n}\n\n@media screen and (max-height: 768px) {\n  .player_bar_container {\n    height: 12vh;\n  }\n  \n  .player_bar_actions_container {\n    top: -30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
